export class ContainerGrades {
  id: number;
  gradeId: number = -1;
  containerId: number = -1;
  createdAt: string;
  updatedAt: string;

}
